import React from 'react';
import { formatCurrency } from '../fundingUtils';

const STAT_ITEMS = [
  { key: 'totalProjects', label: 'Total Projects', format: (v) => String(v) },
  { key: 'totalFundingRaised', label: 'Total Funding Raised', format: (v) => formatCurrency(v) },
  { key: 'activeInvestors', label: 'Active Investors', format: (v) => String(v) },
  { key: 'successStories', label: 'Success Stories', format: (v) => String(v) },
];

export default function FundingStats({ stats }) {
  return (
    <section className="funding-stats" aria-label="Funding statistics">
      <div className="funding-stats-grid">
        {STAT_ITEMS.map((item, i) => (
          <article
            key={item.key}
            className="funding-stat-card"
            style={{ animationDelay: `${i * 0.08}s` }}
          >
            <span className="funding-stat-value">{item.format(stats[item.key] ?? 0)}</span>
            <span className="funding-stat-label">{item.label}</span>
          </article>
        ))}
      </div>
    </section>
  );
}
